import { createFileRoute } from "@tanstack/react-router";
import { OwnResident } from "@/components/app/portal/pages/own-resident";
import { PacketPage } from "@/components/app/portal/packet-page";

export const Route = createFileRoute("/resident-portal/packets/$packetId")({
  head: () => ({ meta: [{ title: "Paperwork | People AI" }] }),
  component: ResidentPacket,
});

/** Admission paperwork the resident signs for themselves. */
function ResidentPacket() {
  const { packetId } = Route.useParams();
  return (
    <OwnResident>
      {(own) => <PacketPage kind="resident" residentId={own.residentId} packetId={packetId} />}
    </OwnResident>
  );
}
